import { type ApiEnvelope, api, unwrap } from "@/lib/api";

/**
 * Compte bancaire à créditer pour un virement client.
 *
 * Ces coordonnées vivaient dans la configuration du serveur : ouvrir un compte
 * de plus demandait cinq variables d'environnement sur trois environnements, et
 * un déploiement. Elles se saisissent désormais ici.
 */
export interface BankAccount {
	id: string;
	bankName: string;
	holder: string;
	accountNumber: string;
	iban: string | null;
	swift: string | null;
	note: string | null;
	isActive: boolean;
	sort: number;
	createdAt: string;
	updatedAt: string;
}

export interface UpsertBankAccountInput {
	bankName?: string;
	holder?: string;
	accountNumber?: string;
	iban?: string | null;
	swift?: string | null;
	note?: string | null;
	isActive?: boolean;
	sort?: number;
}

const BASE = "/admin/bank-accounts";

export const bankAccountsApi = {
	list: () => unwrap<BankAccount[]>(api.get<ApiEnvelope<BankAccount[]>>(BASE)),

	create: (body: UpsertBankAccountInput) =>
		unwrap<BankAccount>(api.post<ApiEnvelope<BankAccount>>(BASE, body)),

	update: (id: string, body: UpsertBankAccountInput) =>
		unwrap<BankAccount>(api.patch<ApiEnvelope<BankAccount>>(`${BASE}/${id}`, body)),

	remove: (id: string) => api.delete(`${BASE}/${id}`),
};
